const projects = [
    {
        id: 1, 
        name: 'Wildstone Infra Hotel', 
        tag: ['Hotel', 'Luxury', 'Infra'], 
        adresse: '2715 Ash Dr. San Jose, South Dakota', 
        imgSrc: '/imgs/projects/1.png' 
    },
    { 
        id: 2, 
        name: 'Wish Stone Building', 
        tag: ['Office', 'Commercial', 'Building'], 
        adresse: '2972 Westheimer Rd. Santa Ana, Illinois', 
        imgSrc: '/imgs/projects/2.png' 
    },
    { 
        id: 3, 
        name: 'Mr. Parkinston’s House', 
        tag: ['Residential', 'Luxury'], 
        adresse: '3517 W. Gray St. Utica, Pennsylvania', 
        imgSrc: '/imgs/projects/3.png' 
    },
    { 
        id: 4, 
        name: 'Oregano Height', 
        tag: ['Residential', 'Apartments'], 
        adresse: '2464 Royal Ln. Mesa, New Jersey', 
        imgSrc: '/imgs/projects/4.png' 
    },
    { 
        id: 5, 
        name: 'Sunrise Villas', 
        tag: ['Luxury', 'Villa', 'Modern'], 
        adresse: '5421 Lemon St. Austin, Texas', 
        imgSrc: '/imgs/projects/5.jpg' 
    },
    { 
        id: 6, 
        name: 'Crystal Tower', 
        tag: ['Commercial', 'Office', 'High-rise'], 
        adresse: '7892 Emerald Ave. Miami, Florida', 
        imgSrc: '/imgs/projects/6.jpg' 
    },
    { 
        id: 7, 
        name: 'Mountain Ridge Estates', 
        tag: ['Residential', 'Luxury', 'Mountain View'], 
        adresse: '9832 Pine Valley Rd. Denver, Colorado', 
        imgSrc: '/imgs/projects/7.jpg' 
    },
    { 
        id: 8, 
        name: 'The Regal Heights', 
        tag: ['Residential', 'Luxury', 'Penthouse'], 
        adresse: '1721 Royal Crest Dr. Los Angeles, California', 
        imgSrc: '/imgs/projects/8.jpg' 
    },
    { 
        id: 9, 
        name: 'Ocean Breeze Tower', 
        tag: ['Commercial', 'Tower', 'Ocean View'], 
        adresse: '5621 Seaside Blvd. San Diego, California', 
        imgSrc: '/imgs/projects/9.jpg' 
    },
    { 
        id: 10, 
        name: 'Greenfield Complex', 
        tag: ['Residential', 'Green', 'Sustainable'], 
        adresse: '4510 Greenway Ln. Portland, Oregon', 
        imgSrc: '/imgs/projects/10.jpg' 
    },
    { 
        id: 11, 
        name: 'Skyline Residences', 
        tag: ['Residential', 'Luxury', 'Skyline View'], 
        adresse: '3012 Hilltop Dr. New York, New York', 
        imgSrc: '/imgs/projects/11.jpg' 
    },
    { 
        id: 12, 
        name: 'The Brookstone Project', 
        tag: ['Residential', 'Apartment', 'Affordable'], 
        adresse: '6785 River Rd. Dallas, Texas', 
        imgSrc: '/imgs/projects/12.jpg' 
    },
    { 
        id: 13, 
        name: 'Riverbend Towers', 
        tag: ['Commercial', 'High-rise', 'Office'], 
        adresse: '1201 River Rd. Houston, Texas', 
        imgSrc: '/imgs/projects/13.jpg' 
    },
    { 
        id: 14, 
        name: 'Harbor View Residences', 
        tag: ['Luxury', 'Harbor View'], 
        adresse: '9442 Harbor St. Miami, Florida', 
        imgSrc: '/imgs/projects/14.jpg' 
    },
    { 
        id: 15, 
        name: 'Pinecrest Heights', 
        tag: ['Residential', 'Suburban', 'Family-friendly'], 
        adresse: '2845 Pine Ave. Chicago, Illinois', 
        imgSrc: '/imgs/projects/15.jpg' 
    },
    { 
        id: 16, 
        name: 'Diamond Park Plaza', 
        tag: ['Commercial', 'Plaza', 'Retail'], 
        adresse: '3901 Diamond St. Atlanta, Georgia', 
        imgSrc: '/imgs/projects/16.jpg' 
    },
    { 
        id: 17, 
        name: 'Violet Ridge Residences', 
        tag: ['Residential', 'Modern', 'Eco-friendly'], 
        adresse: '7284 Violet Dr. Seattle, Washington', 
        imgSrc: '/imgs/projects/17.jpg' 
    },
    { 
        id: 18, 
        name: 'The Crestwood Center', 
        tag: ['Commercial', 'Office', 'Business'], 
        adresse: '1234 Crestwood Rd. Denver, Colorado', 
        imgSrc: '/imgs/projects/18.jpg' 
    },
    { 
        id: 19, 
        name: 'Eagle’s Nest Apartments', 
        tag: ['Residential', 'Apartment', 'Luxury'], 
        adresse: '5643 Eagle View Rd. San Francisco, California', 
        imgSrc: '/imgs/projects/19.jpg' 
    },
    { 
        id: 20, 
        name: 'The Grand Terrace', 
        tag: ['Residential', 'Luxury', 'Terrace'], 
        adresse: '2987 Grand St. Boston, Massachusetts', 
        imgSrc: '/imgs/projects/20.jpg' 
    }
];export default projects;
